import { useQuery, keepPreviousData } from '@tanstack/react-query'
import * as dayjs from 'dayjs'
import { Dayjs } from 'dayjs'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { DashboardData } from './types'

/**
 * Fetches basic company settings.
 */
export function useQueryDashboard(
  companyId: string,
  date?: Date | string | Dayjs,
) {
  const month = date ? dayjs(date).format('YYYY-MM') : undefined

  const enabled = !!companyId && !!month
  return useQuery<DashboardData>({
    queryKey: ['dashboard', companyId, month],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/api/${companyId}/dashboard`, {
        params: { month },
      })
      return data
    },
    enabled,
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
    placeholderData: keepPreviousData,
  })
}
